import { combineReducers } from 'redux';
import {
    PICLIST,
    LOGINSUC,
    LOGINERR,
    FILEUPLOAD,
    VIDEOSUB
} from './action-types';

function picList(state = [], action) {
    switch (action.type) {
        case PICLIST:
            return action.data;
        default:
            return state;
    }
}

const initUser = {
    username: '',
    urls: '',
    islogin: false
}

function userInfo(state = initUser, action) {
    switch (action.type) {
        case LOGINSUC:
            return {...action.data, islogin: true }
        case LOGINERR:
            return {...state, islogin: false }
        default:
            return state;
    }
}

function fileUpload(state = [], action) {
    switch (action.type) {
        case FILEUPLOAD:
            return action.data;
        default:
            return state;
    }
}

function videoSub(state = [], action) {
    switch (action.type) {
        case VIDEOSUB:
            return action.data;
        default:
            return state;
    }
}

export default combineReducers({
    picList,
    userInfo,
    fileUpload,
    videoSub
});


// WEBPACK FOOTER //
// ./src/redux/reducers.js